import React from "react";
import KpiCard from "../../CommonComponents/Dashboard/KpiCard/KpiCard";
import { KPI_CARD_BACKGROUND } from "../../../utils/Constants";

import "./stylesProviderPerformance.css";

import { Line } from "react-chartjs-2";
import { formatNumber } from "chart.js/helpers";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from "chart.js";
import { Skeleton } from "antd";

function ProviderPerformance({ isApiRunning, title, showBottomKpis = true }) {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const labels = [
    "03 Mar",
    "04 Mar",
    "05 Mar",
    "06 Mar",
    "07 Mar",
    "08 Mar",
    "09 Mar",
    "10 Mar",
    "11 Mar",
    "12 Mar",
    "13 Mar",
    "14 Mar",
    "15 Mar",
  ];

  const values = [
    "8119.78",
    "5837.49",
    "7369.01",
    "3339.07",
    "2508.03",
    "2210.66",
    "1371.36",
    "1450.30",
    "440.74",
    "527.95",
    "1136.85",
    "565.13",
    "167.54",
  ];

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Kpis",
        data: values,
        borderColor: "#FD6F27",
        backgroundColor: "#FD6F27",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return `${context.dataset.label}: ${formatNumber(
              value,
              "en-US",
              "decimal",
              2
            )}\n`;
          },
        },
        backgroundColor: "#25252F",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 20,
        displayColors: true,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value / 1000 + "k";
          },
        },
      },
    },
    interaction: {
      mode: "index", // Show tooltip for all datasets at hovered index
      intersect: false,
      axis: "x", // Ensure crosshair lines show on the x-axis
    },
  };

  return (
    <div className="provider-performance-container">
      <div className="provider-performance-body">
        <h2>{title}</h2>
        <div className="provider-performance-top">
          {isApiRunning ? (
            <div
              style={{
                width: "100%",
                height: "300px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Skeleton active />
            </div>
          ) : (
            <div className="provider-performance-top-left-content">
              {showBottomKpis ? (
                <h3>TURNOVER BY DAY</h3>
              ) : (
                <h3>TOTAL EVENTS</h3>
              )}

              <div className="principal-kpi">
                <p className="kpi">$30,000</p>
                <p className="description">
                  <span>3%</span> vs last month
                </p>
              </div>
              <div style={{ height: "100%", width: "100%" }}>
                <Line data={data} options={options} />
              </div>
            </div>
          )}
          <div className="provider-performance-top-right-content">
            <div className="right-content-top">
              <KpiCard
                isApiRunning={isApiRunning}
                title={showBottomKpis ? "TURNOVER" : "FUTURE"}
                value={600000}
                hugeValue={false}
                percentage={-50}
                backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
              />
              <KpiCard
                isApiRunning={isApiRunning}
                title={showBottomKpis ? "GGR" : "LIVE"}
                value={6000}
                customColor={showBottomKpis ? "#34C759" : null}
                hugeValue={false}
                percentage={-10}
                backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
              />
            </div>
            <div className="right-content-bottom">
              <KpiCard
                isApiRunning={isApiRunning}
                title={showBottomKpis ? "TOTAL BETS" : "COMPLETED"}
                value={6000}
                hugeValue={false}
                percentage={35}
                backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
              />
              <KpiCard
                isApiRunning={isApiRunning}
                title={showBottomKpis ? "MARGIN" : "HIDDEN"}
                value={6.5}
                hugeValue={false}
                percentage={-5}
                backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
              />
            </div>
          </div>
        </div>
        <div
          className="provider-performance-bottom"
          style={showBottomKpis ? { display: "flex" } : { display: "none" }}
        >
          <KpiCard
            isApiRunning={isApiRunning}
            title="TOTAL AVAILABLE EVENTS"
            value={100000}
            hugeValue={false}
            percentage={3}
            backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
          />
          <KpiCard
            isApiRunning={isApiRunning}
            title="AVG BET AMOUNT"
            value={100}
            hugeValue={false}
            percentage={-3}
            backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
          />
          <KpiCard
            isApiRunning={isApiRunning}
            title="PLAYERS ENGAGED"
            value={27200}
            hugeValue={false}
            percentage={-80}
            backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
          />
        </div>
      </div>
    </div>
  );
}

export default ProviderPerformance;
